/* eslint-disable */
// leave off @2x/@3x
const images = {
  logo: require('../Images/gfxLogo.png'),
  cafe: require('../Images/cafe.png'),

  homeIcon: require('../Images/home-icon-white_v2.png'), // home-icon-blue-updated.png'),
  homeIconWhite: require('../Images/home-icon-white_v2.png'),
  exploraIcon: require('../Images/Icons/explora_v2.png'),
  exploraIconWhite: require('../Images/Icons/explora_w_v2.png'),
  qrCodeIcon: require('../Images/Icons/qrCodeIcon_w.png'),
  outofdate: require('../Images/appnotworking.png'),

  loginBackground: require('../Images/hd-mountain-bg.jpg'),
  loginLogo: require('../Images/logo-with-text.png'),
  loginLogoOther: require('../Images/logo-with-textorig.png'),
  loginIconRow: require('../Images/loginIconRow.png'),
  loginButton: require('../Images/login.png'),
  loginWithFacebookButton: require('../Images/login-with-facebook.png'),
  signupAvatarType: require('../Images/signup-avatar-type.png'),
  signupAvatarBg: require('../Images/signup-avatar-bg.jpg'),
  signupAvatarProfile: require('../Images/profile_setup.png'),
  longArrowRight: require('../Images/long-arrow-right.png'),
  postlinkScrollIndicator: require('../Images/postlink-scroll-indicator.png'),
  postlinkAddTag: require('../Images/postlink-addtag.png'),
  postlinkPost: require('../Images/postlink-post.png'),
  v2ExploraPeople: require('../Images/v2-explora-people.jpg'),
  v2ExploraDiscover: require('../Images/v2-explora-discover.jpg'),
  v2ExploraKargoetag: require('../Images/v2-explora-kargoetag.jpg'),
  v2ExploraShopping: require('../Images/v2-explora-shopping.jpg'),
  sorryNoResults: require('../Images/sorry-no-results-v2.jpg'),
  sorryNoMoneyResults: require('../Images/sorry-no-money-results-v2.png'),
  startAConversation: require('../Images/start-a-conversation.jpg'),

  fbShareRound: require('../Images/facebook-logo-2019.png'),
  twitterShareRound: require('../Images/official-twitter-logo.png'),
  instagramShareRound: require('../Images/instagramLogoHiRes.png'),

  // downward pointing arrow for selecting an option
  arrowSelectGradient: require('../Images/arrow-select-gradient.png'),

  disclosureUp: require('../Images/icDisclousureUp.png'),
  disclosure: require('../Images/icDisclousure.png'),
  delivery: require('../Images/icDelivery.png'),
  noAvatar: require('../Images/icNoavatar.png'),
  avatarShadow: require('../Images/avatar_shadow_v1.png'),
  camera: require('../Images/icCameraSmall.png'),
  clearLogo: require('../Images/top_logo.png'),
  launch: require('../Images/launch-icon.png'),
  ready: require('../Images/your-app.png'),
  ignite: require('../Images/ignite_logo.png'),
  igniteClear: require('../Images/ignite-logo-transparent.png'),
  tileBg: require('../Images/tile_bg.png'),
  background: require('../Images/BG.png'),
  buttonBackground: require('../Images/button-bg.png'),
  api: require('../Images/Icons/icon-api-testing.png'),
  components: require('../Images/Icons/icon-components.png'),
  deviceInfo: require('../Images/Icons/icon-device-information.png'),
  faq: require('../Images/Icons/faq-icon.png'),
  home: require('../Images/Icons/icon-home.png'),
  theme: require('../Images/Icons/icon-theme.png'),
  usageExamples: require('../Images/Icons/icon-usage-examples.png'),
  add: require('../Images/Icons/icon-add.png'),
  closeWhite: require('../Images/Icons/icon-close.png'),

  chevronRight: require('../Images/Icons/chevron-right.png'),
  hamburger: require('../Images/Icons/hamburger.png'),
  backButton: require('../Images/Icons/back-button.png'),
  grid: require('../Images/Icons/icon-grid-layout.png'),
  gridWhite: require('../Images/Icons/icon-grid-layout_w.png'),
  gridProfile: require('../Images/Icons/icon-profile-grid-layout.png'),
  listProfile: require('../Images/Icons/icon-profile-list-layout.png'),
  mosaicProfile: require('../Images/Icons/icon-profile-mosaic-layout.png'),
  online: require('../Images/Icons/icon-available.png'),
  list: require('../Images/Icons/icon-list-layout.png'),
  listWhite: require('../Images/Icons/icon-list-layout_w_v2.png'),
  mosaic: require('../Images/Icons/icon-mosaic-layout.png'),
  mosaicWhite: require('../Images/Icons/icon-mosaic-layout_w.png'),
  more: require('../Images/more.png'),
  music: require('../Images/Icons/music.png'),
  playMusic: require('../Images/Icons/play_music.png'),

  barCodeIcon: require('../Images/bar-code-icon.png'),
  menuIcon: require('../Images/hamburger.png'),
  menuIconWhite: require('../Images/hamburger_w.png'),
  spacerForKeyboardAvoidingView: require('../Images/spacer.png'),

  paypalProblems: require('../Images/paypal-problems.png'),
  shoppableProblems: require('../Images/shoppable-problems.png'),
  bigThumbsDown: require('../Images/big_thumbs_down.jpg'),
  bigThumbsUp: require('../Images/big_thumbs_up.jpg'),
  addFriend: require('../Images/icAddFriend.png'),
  backNav: require('../Images/icBackNav.png'),
  card: require('../Images/icCard.png'),
  crossNav: require('../Images/icCrossNav.png'),
  crossSmall: require('../Images/icCrossSmall.png'),
  deleteRed: require('../Images/icDeleteRed.png'),
  deleteBtn: require('../Images/delete-btn.png'),
  facebookLogo: require('../Images/icFbconnect.png'),
  flashOn: require('../Images/icFlashOn.png'),
  flashOff: require('../Images/icFlashOff.png'),
  frontFacing: require('../Images/icFrontfacing.png'),
  gradient: require('../Images/gfxGradient.png'),
  kargoeNav: require('../Images/icKargoeNav.png'),
  pencil: require('../Images/icPencil.png'),
  personal: require('../Images/icPersonal.png'),
  pin: require('../Images/icPin.png'),
  plusGreen: require('../Images/icPlusGreen.png'),
  profiles: require('../Images/combinedShape.png'),
  rearFacing: require('../Images/icRearfacing.png'),
  receipts: require('../Images/icReciepts.png'),
  removeFriend: require('../Images/icRemoveFriend.png'),
  settings: require('../Images/icSetinngsNav.png'),
  slideArrow: require('../Images/icSliderarrow.png'),
  kargoeLogoHome: require('../Images/kargoeLogoHome_v2.png'),
  kargoeLogoHomeWhite: require('../Images/kargoeLogoHome_w.png'),
  //
  greenStar: require('../Images/green-star.png'),
  greyStar: require('../Images/grey-star.png'),

  paypal: require('../Images/paypal-icon.png'),
  paypalCheckout: require('../Images/paypal-normal.png'),
  paypalCheckoutNoWords: require('../Images/paypal-normal-nowords.png'),
  paypalCheckoutClicked: require('../Images/paypal-clicked.png'),
  creditCheckout: require('../Images/creditcard-normal.png'),
  creditCheckoutNoWords: require('../Images/creditcard-normal-nowords.png'),
  creditCheckoutClicked: require('../Images/creditcard-clicked.png'),
  paypalLogin: require('../Images/login-with-paypal.png'),
  paypalLogout: require('../Images/log-out-of-paypal.png'),
  svgDeliveryAdress: require('../Images/Icons/delivery-address.svg'),
  svgEditProfile: require('../Images/Icons/edit-profile.svg'),
  svgKargoCare: require('../Images/Icons/kargoe-care.svg'),
  svgPushnotice: require('../Images/Icons/push-notification.svg'),
  svgTouchid: require('../Images/Icons/touch-id.svg'),
  // animation
  marquee: require('../Images/animations/marquee.json'),
  spinnerDark: require('../Images/animations/spinner/dark.json'),
  spinnerLight: require('../Images/animations/spinner/light.json'),
  loveAnimation: require('../Images/animations/lovev4.json'),
  dotdotdot: require('../Images/animations/lottie....json'),
  splashLogo: require('../Images/animations/kargoe-loading-infinite-transparent.gif'),
  refreshControl: require('../Images/animations/refreshControl.gif'),
  myLocation: require('../Images/animations/mylocation.gif'),
  eyeBlinking: require('../Images/animations/3774-blink-of-an-eye.json'),
	eyeNotBlinking: require('../Images/eye-not-blinking.png'),
	eyeNotBlinkingWhite: require('../Images/eye-not-blinking-white.png'),
  musicNotes: require('../Images/animations/2881-music-fly.json'),
  streamHearts: require('../Images/animations/58137-heart-burst.json'),
  // profile
  addPhoneGrey: require('../Images/profile/icon-add-phone-grey.png'),
  bio: require('../Images/profile/icon-bio.png'),
  emailGrey: require('../Images/profile/icon-email-grey.png'),
  emailWhite: require('../Images/profile/icon-email.png'),
  passGrey: require('../Images/profile/icon-password-grey.png'),
  username: require('../Images/profile/icon-username-grey.png'),
  people: require('../Images/3.jpg'),
  discover: require('../Images/1.jpg'),
  kargoetags: require('../Images/2.jpg'),

  // thumb wall Icons
  iconThumbPause: require('../Images/Icons/pauseIcon.png'),
  iconThumbPlay: require('../Images/Icons/icon-thumb-play.png'),   // just a black triangle with a white border
  iconThumbPlay2: require('../Images/Icons/icon-thumb-play2.png'), // semi-transparent circle around it
  iconThumb3D: require('../Images/Icons/icon-thumb-tilt.png'),
  iconThumbKargoeTags: require('../Images/Icons/icon-thumb-kargoetags.png'),
  iconThumbLinkWhite: require('../Images/Icons/icon-thumb-link-white.png'),

  // single wall Icons
  iconSinglePlay: require('../Images/Icons/icon-thumb-play2.png'), // '../Images/Icons/icon-single-play.png'
  iconSingle3D: require('../Images/Icons/icon-single-tilt.png'),
  iconSingleKargoeTags: require('../Images/Icons/icon-single-kargoetags.png'),
  iconSingleLinkBlue: require('../Images/Icons/icon-single-link-blue.png'),
  iconSingleLinkWhite: require('../Images/Icons/icon-single-link-white.png'),
  iconSingleSoundOn: require('../Images/Icons/icon-single-sound-on.png'),
  iconSingleSoundOff: require('../Images/Icons/icon-single-sound-off.png'),
  tapForVideoWall: require('../Images/tap-for-video-wall.png'),
  space: require('../Images/spacer.png'),
  blankVideo: require('../Images/videos/dark_video.mp4'),
  newPostBtn: require('../Images/newpost-btn.png'),
  newPostButton: require('../Images/NewPostButton_v2NoWords.png'),
  settingsBtn: require('../Images/SettingsButton.png'),
  joinMeBtn: require('../Images/join-me.png'),
  shoppingDot: require('../Images/shopping-dot.png'),
  moreGradient: require('../Images/more_gradiant.png'),
  // blank.mp4'),

  // single wall footer
  viewsIcon: require('../Images/Icons/views.png'),
  lovesOnIcon: require('../Images/Icons/loves-on.png'),
  lovesOffIcon: require('../Images/Icons/loves-off.png'),
  commentsOnIcon: require('../Images/Icons/comment-on.png'),
  commentsOffIcon: require('../Images/Icons/comment-off.png'),
  kargoeTagsOnIcon: require('../Images/Icons/kargoetag-on.png'),
  kargoeTagsOffIcon: require('../Images/Icons/kargoetag-off.png'),
  hashTagsIcon: require('../Images/Icons/hashtag_orginal.png'),
  shoppingOffIcon: require('../Images/Icons/shoppingbag-off.png'),
  shoppingOnIcon: require('../Images/Icons/shoppingbag-on.png'),
  dollarWall: require('../Images/Icons/dollarWall.png'),
  newWallet: require('../Images/newWallet_v2.png'),
  newWalletWhite: require('../Images/newWallet_w_v2.png'),
  heartWall: require('../Images/Icons/heartWall_v2.png'),
  heartWallWhite: require('../Images/Icons/heartWall_w_v2.png'),
  heartWallSolid: require('../Images/Icons/heartWall_v2_solid.png'),
  heartWallWhiteSolid: require('../Images/Icons/heartWall_w_v2_solid.png'),
  messageWallOn: require('../Images/Icons/messageWallOnAug14.png'),
  messageWallOff: require('../Images/Icons/messageWallOff_v2.png'),
  messageWallOffWhite: require('../Images/Icons/messageWallOff_w_v2.png'),

  messageWallOffTele:  require('../Images/Icons/messageWallOff_v2_withTele.png'),
  messageWallOffTeleWhite:  require('../Images/Icons/messageWallOff_w_v2_withTele.png'),

  optionsIcon: require('../Images/Icons/ellipsis.png'),
  shareIconBlack: require('../Images/Icons/share_icon_ios_black.png'),
  shareIconWhite: require('../Images/Icons/share_icon_ios_white.png'),

	fsEyeIconWhite: require('../Images/Icons/fs-eye-icon-white.png'),
	fsLoveHeartWhite: require('../Images/Icons/fs-love-heart-white.png'),
	fsCommentBubbleWhite: require('../Images/Icons/fs-comment-bubble-white.png'),
	fsCommentBubbleRed: require('../Images/Icons/fs-comment-bubble-red.png'),
	fsShoppingBagWhite: require('../Images/Icons/fs-shopping-bag-white.png'),
	fsShoppingBagRed: require('../Images/Icons/fs-shopping-bag-red.png'),
	fsBackArrowWhite: require('../Images/Icons/fs-back-arrow-white_v2.png'),

  // upload test - NOTE: React does not like filenames with uppercase letters, even extensions
  uploadTestMain: require('../Images/upload_tests/test_pic_1.jpg'),
  uploadTestThumb: require('../Images/upload_tests/test_pic_1_thumb.jpg'),

  charityMarker: require('../Images/art-board-marker.png'),
  vendorMarker: require('../Images/money-marker.png'),
  moneyFace: require('../Images/money-face.png'),

  appleBlack: require('../Images/apple_black.png'),
  enlargeIconWhite: require('../Images/Icons/enlarge_icon_white.png'),

  audioWave1: require('../Images/Icons/voice-audio-icon.png'),

  micOnWall: require('../Images/Icons/micOnWall.png'),
  
  soundOffBlack: require('../Images/Icons/sound-off-black.png'),
  soundOnBlack: require('../Images/Icons/sound-on-black.png'),

  soundBlackShadowOff: require('../Images/Icons/sound-black-shadow-off.png'),
  soundBlackShadowOn: require('../Images/Icons/sound-black-shadow-on.png'),

  stopMusic: require('../Images/Icons/stop_music.png'),
  deleteButtonBlack: require('../Images/Icons/delete-button-black.png'),
  
  wallMusicBackground: require('../Images/wall-music-background-gradient.png'),
  wallFullScreenBackground: require('../Images/wall-fullscreen-background-gradient.png'),

  buttonCloseLiveBroadcast: require('../Images/Icons/btn_close_live_broadcast.png'),

  airplaneNew: require('../Images/Icons/airplaneNew.png'),

  flipCamera: require('../Images/Icons/flip-camera.png'),

  beautify:  require('../Images/Icons/beautify.png'),

  streamMicrophoneGrayscale:  require('../Images/Icons/microphone_btn_grayscale.png'),
  streamCameraGrayscale:  require('../Images/Icons/camera_btn_grayscale.png'),

  streamMuteWhite:  require('../Images/Icons/mute_btn_white.png'),
  streamFlipCameraWhite:  require('../Images/Icons/flip_camera_btn_white.png'),
  streamBeautifyWhite:  require('../Images/Icons/beautify_btn_white.png'),
  streamHDWhite:  require('../Images/Icons/hd_btn_white.png'),
  // streamGoldCoinIcon:  require('../Images/Icons/canadian_gold_coin.png'),
  // streamGoldCoinGrayscaleIcon:  require('../Images/Icons/canadian_gold_coin_grayscale.png'),
  // streamGoldCoinIcon:  require('../Images/Icons/kcoin.png'),
  streamGoldCoinIcon:  require('../Images/Icons/kargoetoken.png'),
  streamTokenFishIcon:  require('../Images/Icons/token_fish_200.png'),
  streamTokenUfoIcon:  require('../Images/Icons/token_ufo_200.png'),
  streamTokenCherryIcon:  require('../Images/Icons/token_cherries_200.png'),
  streamViewingIcon:  require('../Images/Icons/viewed_eye_icon.png'),
  streamMinimizeIcon: require('../Images/Icons/minimize_icon_white.png'),

  // token previews
  tokenPreviewRocket1: require('../Images/animations/tokens/token-preview-rocket1.png'),
  tokenPreviewRocket2: require('../Images/animations/tokens/token-preview-rocket2.png'),
  tokenPreviewRocket3: require('../Images/animations/tokens/token-preview-rocket3.png'),
  tokenPreviewBanana: require('../Images/animations/tokens/token-preview-banana.png'),
  tokenPreviewMushroomJumping: require('../Images/animations/tokens/token-preview-mushroom.png'),
  tokenPreviewFlirtingDog: require('../Images/animations/tokens/token-preview-dogge.png'),
  tokenPreviewSushiBelt: require('../Images/animations/tokens/token-preview-sushi.png'),
  tokenPreviewBallOfFire: require('../Images/animations/tokens/token-preview-fireball.png'), // token-preview-ball-of-fire.png
  tokenPreviewFireworks: require('../Images/animations/tokens/token-preview-fireworks.png'),
  tokenPreviewNeonHearts: require('../Images/animations/tokens/token-preview-hearts-neon.png'),
  tokenPreviewKingGoldCrown: require('../Images/animations/tokens/token-preview-crown.png'),
  tokenPreviewMouth: require('../Images/animations/tokens/token-preview-mouth.png'),
  tokenPreviewGoodMorning: require('../Images/animations/tokens/token-preview-morning-sun.png'),
  tokenPreviewPlane: require('../Images/animations/tokens/token-preview-airplane.png'),
  tokenPreviewDragon: require('../Images/animations/tokens/token-preview-dragon.png'),
  tokenPreviewPeach: require('../Images/animations/tokens/token-preview-peach.png'),
  tokenPreviewDog: require('../Images/animations/tokens/token-preview-dog.png'),

  // token animations
  tokenAnimationRocket1: require('../Images/animations/tokens/11036-rocket.json'),
  tokenAnimationRocket2: require('../Images/animations/tokens/5566-rocket.json'),
  tokenAnimationRocket3: require('../Images/animations/tokens/token-animation-rocket3.json'), // /5566-rocket.json'), // 35618-rocket.json
  tokenAnimationBanana: require('../Images/animations/tokens/token-animation-banana.json'), // /48948-banana.json'),
  tokenAnimationMushroomJumping: require('../Images/animations/tokens/10749-mushroom-jumping.json'),
  tokenAnimationFlirtingDog: require('../Images/animations/tokens/19934-flirting-dog.json'),
  tokenAnimationSushiBelt: require('../Images/animations/tokens/38717-sushi-belt.json'),
  tokenAnimationBallOfFire: require('../Images/animations/tokens/token-animation-fireball.json'), // 16872-ball-of-fire.json
  tokenAnimationFireworks: require('../Images/animations/tokens/26287-fireworks.json'),
  tokenAnimationNeonHearts: require('../Images/animations/tokens/44919-neon-hearts.json'),
  tokenAnimationKingGoldCrown: require('../Images/animations/tokens/26913-king-gold-crown.json'),
  tokenAnimationMouth: require('../Images/animations/tokens/57882-mouth.json'),
  tokenAnimationGoodMorning: require('../Images/animations/tokens/16872-ball-of-fire.json'), // 53625-good-morning.json
  tokenAnimationPlane: require('../Images/animations/tokens/57545-plane.json'),
  tokenAnimationDragon: require('../Images/animations/tokens/26907-castle-dragon-palace'),
  tokenAnimationPeach: require('../Images/animations/tokens/token-animation-peach.json'),
  tokenAnimationDog: require('../Images/animations/tokens/token-animation-dog.json'),

  kargoeSticker:  require('../Images/kargoe_sticker.png'), // wyd
  kargoeStickerIcon:  require('../Images/kargoe_sticker_icon.png'), // wyd small

  newMicOn:  require('../Images/Icons/newMicOn.png'),
  newMicOff:  require('../Images/Icons/newMicOff.png'),

  soundwave:  require('../Images/soundwave.png'), // for live stream mic-only view

  funraiser: require('../Images/funraiser.png'),

  streamsaveglitch: require('../Images/streamsaveglitch1.jpg'),

  mirrorImage : require('../Images/Icons/mirror-image.png'),

  telegramLogo : require('../Images/Icons/tele_logo_2x.png')

}

// drop new images into XCode > ignite1 > Resources and rebuild from scratch

export default images
